module.exports = __webpack_public_path__ + "static/img/hopwood-cody.ea00a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hopwood-cody.jpg
// module id = WjUM
// module chunks = 0